<app-search-box-map (placeLogged)="onPlaceLogged($event)"/>
<google-map
  height="500px"
  width="100%"
  [center]="selectedPosition ?? center"
  [zoom]="zoom"
  (mapClick)="onMapClick($event)"
  >
  @for (marker of searchBoxMarker; track marker.position) {
    <map-marker
      [position]="marker.position"
      [title]="marker.title ?? ''">
    </map-marker>
  }
  @if (selectedPosition) {
    <map-marker [position]="selectedPosition"
    ></map-marker>
  }
</google-map>

